export default __webpack_public_path__ + "static/media/pexels-jess-bailey-designs-860009.755ddd74.jpg";